export enum NewsletterSuppressionReason {
  HardBounce = 0,
  SoftBounce = 1,
  Complaint = 2,
  Unsubscribe = 3,
}

export const newsletterSuppressionReasonTranslations: Record<NewsletterSuppressionReason, string> = {
  [NewsletterSuppressionReason.HardBounce]: 'newsletter.suppressions.reason.hard_bounce',
  [NewsletterSuppressionReason.SoftBounce]: 'newsletter.suppressions.reason.soft_bounce',
  [NewsletterSuppressionReason.Complaint]: 'newsletter.suppressions.reason.complaint',
  [NewsletterSuppressionReason.Unsubscribe]: 'newsletter.suppressions.reason.unsubscribe',
};

export const newsletterSuppressionReasonOptions = [
  {
    text: newsletterSuppressionReasonTranslations[NewsletterSuppressionReason.HardBounce],
    val: NewsletterSuppressionReason.HardBounce,
  },
  {
    text: newsletterSuppressionReasonTranslations[NewsletterSuppressionReason.SoftBounce],
    val: NewsletterSuppressionReason.SoftBounce,
  },
  {
    text: newsletterSuppressionReasonTranslations[NewsletterSuppressionReason.Complaint],
    val: NewsletterSuppressionReason.Complaint,
  },
  {
    text: newsletterSuppressionReasonTranslations[NewsletterSuppressionReason.Unsubscribe],
    val: NewsletterSuppressionReason.Unsubscribe,
  },
];
